export enum RingModelEnum {
  Gen3 = 'oura-gen3',
  Oura4 = 'oura-ring-4',
}
